/**
 * Disable Shopify Page Transitions
 * 
 * Page transitions cause conflicts with multiple third-party scripts
 * (GTM, WebEngage, GoKwik, Clarity, etc.) during navigation.
 * 
 * This script disables the page transition feature to prevent freezes.
 */
(function() {
  'use strict';
  
  // Override the theme setting
  if (window.themeVariables && window.themeVariables.settings) {
    window.themeVariables.settings.showPageTransition = false;
    console.log('[PageTransitions] Disabled to prevent conflicts with third-party scripts');
  }
  
  // Also intercept any link clicks that might trigger page transitions
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    
    // Allow normal navigation for internal links
    if (href && href.startsWith('/') && !href.startsWith('//')) {
      // Remove any data attributes that trigger page transitions
      link.removeAttribute('data-transition');
      link.removeAttribute('data-barba');
    }
  }, true); // Use capture phase to intercept early
  
})();
